import PropTypes from "prop-types";
import { getContext } from "recompose";

export default getContext({
  router: PropTypes.object
});



// WEBPACK FOOTER //
// ./src/components/RouterContext.js